import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { costBreakdownWidgetViewDataSelector } from "./costBreakdownWidgetViewDataSelector";

export const costBreakdownWidgetTableViewDataCountSelector =
  createDraftSafeSelector([costBreakdownWidgetViewDataSelector], (data) => {
    return data?.length ?? 0;
  });
